module.exports = __webpack_public_path__ + "static/img/login.b5a3ca9c.png";